<template>
  <div>
    <h3>local Video</h3>

    <!-- video sample -->
    <video
      @click="selectMainVideo"
      src="/static/video/sample.webm"
      class="video-small"
      ref="localVideo"
    />

    <!-- player visible -->
    <div>
      <el-button :disabled="visible" @click="changeVisible(true)">show</el-button>
      <el-button :disabled="!visible" @click="changeVisible(false)">hide</el-button>
    </div>

    <!-- seek bar -->
    <el-slider
      :format-tooltip ="timeFormat"
      :max            ="duration"
      v-model         ="time"
    />
    <div>{{timeFormat(player.currentTime)}}/{{timeFormat(duration)}}</div>

    <!-- controll button -->
    <el-button :disabled="!player.paused" @click="player.play()">play</el-button>
    <el-button :disabled="player.paused" @click="player.pause()">pause</el-button>
    <el-button @click="changeCurrentTime(0)">begin</el-button>

    <!-- file loader -->
    <div
      style="height: 100px;
        width: 300px;
        margin: auto;
        backgroundColor: #000;
      "
      @dragleave.prevent
      @dragover.prevent
      @drop.prevent="onDrop"
    >
      <input type="file" @change="selectFile">
    </div>

  </div>
</template>

<script lang="">
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {}
  },
  props    : [],
  computed : {
    time: {
      get () { return this.currentTime },
      set (value) {
        this.changeCurrentTime(value)
        if (Math.abs(value - this.player.currentTime) >= 1) {
          this.player.currentTime = value
        }
      }
    },
    ...mapGetters('video', [
      'currentTime',
      'duration',
      'player',
      'visible'
    ])
  },
  methods: {
    selectMainVideo (e) {
      this.player.src = e.target.src
    },

    // file loader
    onDrop (e) {
      const files = e.dataTransfer.files
      console.log(files)
      Object.keys(files).forEach(key => {
        if (files[key].type.indexOf('video') !== -1) {
          this.$refs.localVideo.src = URL.createObjectURL(files[key])
        }
      })
    },
    selectFile (e) {
      const files = e.target.files
      Object.keys(files).forEach(key => {
        if (files[key].type.indexOf('video') !== -1) {
          this.$refs.localVideo.src = URL.createObjectURL(files[key])
        }
      })
    },

    timeFormat (value) {
      const h = Math.floor(value / 3600)
      const m = '0' + Math.floor(value / 60) % 60
      const s = '0' + Math.floor(value % 60) % 60
      return `${h}:${m.slice(-2)}:${s.slice(-2)}`
    },

    ...mapMutations('video', [
      'changeCurrentTime',
      'setLocalStream',
      'changeVisible'
    ])
  }
}
</script>

<style scoped>
.video-small {
  position : relative;
  width    : 200px;
  height   : auto;
  z-index  : 500;
}
</style>



// WEBPACK FOOTER //
// src/components/video/controller/video-file-controller.vue